import {Store} from "vuex";
import {watch} from "vue";
import {COLORMODULE_POSSIBLE_STATES} from "@km/components/color/ModuleColorAnimationStates";
import {AnimationWaitingForTargetFactory, KeyFrameTargetValues} from "@km/animations/animationFactory";
import {useModuleColorOpenStateStore} from "@km/store/frontendstate/useModuleColorOpenState";

export class ColorAnimationVerwalter {
    private static store: Store<any>;
    private static animationStateStore:ReturnType<typeof useModuleColorOpenStateStore>
    public constructor(store: Store<any>) {
        ColorAnimationVerwalter.store = store;
        ColorAnimationVerwalter.animationStateStore = useModuleColorOpenStateStore();
        watch(() => ColorAnimationVerwalter.store.getters.COLORSTABisOpen, (isOpen: boolean) => {
            isOpen ?
                ColorAnimationVerwalter.animationStateStore.ensureStateIsNotClosed() :
                ColorAnimationVerwalter.setModuleColorState(COLORMODULE_POSSIBLE_STATES.closed);
        })
    }

    public static setModuleColorState = (state: COLORMODULE_POSSIBLE_STATES) =>
        ColorAnimationVerwalter.animationStateStore.setCurrentState(state);

    public static getColorShadeGroupAnimation() {
        const animation = AnimationWaitingForTargetFactory.getLeftRightAnimationpercentWithOpacityAnimation(
            '.km__modules__color--shadegroup-selection'
        );
        const keyframes = new KeyFrameTargetValues({targetValue: -100, opacity: 1}, {targetValue: 100, opacity: 0});
        const getterForWatch = () => ColorAnimationVerwalter.animationStateStore.getShadeGroupState;
        return {animation, keyframes, getterForWatch}
    }

    public static getColorShadeAnimation() {
        const animation = AnimationWaitingForTargetFactory.getFadeInOutAnimation(".km__modules__color--shade");
        const keyframes = new KeyFrameTargetValues({targetValue: 9999, opacity: 1}, {targetValue: -9999, opacity: 0});
        const getterForWatch = () => ColorAnimationVerwalter.animationStateStore.getShadeState;
        return {animation, keyframes, getterForWatch}
    }

    public static closeOneLayer = () => ColorAnimationVerwalter.animationStateStore.goBackOneLevel();
}